import {withTraceparent} from "@/functions/getTraceparent";
import {sendAuthenticatedRequest} from "@/functions/authenticatedRequest";

// Link-mode state for the partner link-or-create flow (thauth
// docs/sso-account-linking-plan.md). Set from the LINK_OR_CREATE token-exchange
// response, carried in sessionStorage so a mid-flow refresh survives (the server-side
// pending record's 45 min TTL bounds staleness), and consumed by the explicit
// link-commit call once a fresh session exists. Never committed ambiently: only
// PartnerLinkComplete calls commitPartnerLink.

const linkCommitApi = process.env.VUE_APP_OIDC_LINK_COMMIT_API
const STORAGE_KEY = 'partnerLink'

export const setPartnerLink = (data) => {
	sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
		pendingLinkToken: data.pendingLinkToken,
		provider: data.provider || '',
		suggestedUsername: data.suggestedUsername || '',
		email: data.email || '',
		phoneNumber: data.phoneNumber || '',
	}))
}

export const getPartnerLink = () => {
	const raw = sessionStorage.getItem(STORAGE_KEY)
	if (!raw) {
		return null
	}
	try {
		return JSON.parse(raw)
	} catch {
		sessionStorage.removeItem(STORAGE_KEY)
		return null
	}
}

export const clearPartnerLink = () => {
	sessionStorage.removeItem(STORAGE_KEY)
}

// "everlance" -> "Everlance"
export const partnerDisplayName = (provider) => {
	if (!provider) {
		return 'partner'
	}
	return provider.charAt(0).toUpperCase() + provider.slice(1)
}

// The explicit link-mode commit: attaches the pending partner identity to the account
// whose fresh session cookie rides on this request. Returns {linked: true, provider}
// or {linked: false, errorCode, alert?}.
export const commitPartnerLink = async (router) => {
	const partnerLink = getPartnerLink()
	if (!partnerLink || !partnerLink.pendingLinkToken) {
		return {linked: false, errorCode: 'no_pending_link'}
	}
	try {
		const res = await sendAuthenticatedRequest(linkCommitApi, router, {
			method: 'POST',
			credentials: 'include',
			headers: withTraceparent({
				'Content-Type': 'application/json',
			}),
			body: JSON.stringify({pendingLinkToken: partnerLink.pendingLinkToken})
		})
		// The shared wrapper swallows transport errors and hands back undefined.
		if (!res) {
			return {linked: false, errorCode: 'link_failed'}
		}
		const data = await res.json().catch(() => ({}))
		if (res.ok && data.linked) {
			return {linked: true, provider: data.provider}
		}
		return {linked: false, errorCode: data.errorCode || 'link_failed', alert: data.alert}
	} catch (e) {
		console.error('Partner link commit failed:', e)
		return {linked: false, errorCode: 'link_failed'}
	}
}
